import React, { PureComponent } from "react";
import { downloadCanvasWithTitle, downloadCSVData } from "../utils";
import * as d3 from "d3";
import NoData from "../NoData/NoData";
import TopTopicsChart from "./TopTopicsChart";
import "./TopTopics.scss";
import html2canvas from "html2canvas";
import SentimentSelector from "../SentimentSelectors";
import VolumeSelector from "../VolumeSelectors";
import DimmerComponent from "../../DimmerComponent";
import CustomCheckBox from "../ChartsOptionsSidebar/CustomCheckBox";

import { ReactComponent as Settings } from "../../../../../assets/svg/settings.svg";
import { ReactComponent as MoreOptions } from "../../../../../assets/svg/menu.svg";
import { showChartsDrilldown } from "../../../../../actions/dashboardAction";
import ChartOptionsSidebar from "../ChartsOptionsSidebar/ChartOptionsSidebar";
import DeleteWidget from "../ChartsOptionsSidebar/DeleteWidget";
import { ReactComponent as CloneIcon } from "../../../../../assets/svg/clone-icon.svg";
import { ReactComponent as TranslateIcon } from "../../../../../assets/translate.svg";
import { ChartFilterIcon } from "../ChartFilterOptions";
import ChartName from "../ChartName";
import { connect } from "react-redux";
import DownloadChart from "../DownloadChart";

import { ReactComponent as MiniMize } from "../../../../../assets/svg/zoom_in_map.svg";
import { ReactComponent as MaxiMize } from "../../../../../assets/svg/zoom_out_map.svg";
import Popup from "semantic-ui-react/dist/es/modules/Popup";
import TranslateWords from "./TranslateWords";
class TopTopics extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            sentiment: "all",
            clustering_sort_by: "volume",
            showMore: false,
            showMoreLoading: false,
            translateWords: false,
        };
    }

    formatIndividualBucket(bkt) {
        return {
            ...bkt,
        };
    }

    handleSentimentChange = (val) => {
        if (val !== "All" && val !== "default") {
            this.props.fetchDataFromWidget({
                sentiment: val,
            });
        } else {
            this.props.fetchDataFromWidget({
                sentiment: "",
            });
        }
    };

    handleSortByChange = (val) => {
        this.props.fetchDataFromWidget({
            clustering_sort_by: val,
        });
    };

    formatData = (data) => {
        data = data.data;
        let csvObj = {
            columns: [
                [
                    "Category Rank",
                    "Category Name",
                    `Volume Of Posts`,
                    "Total Impact",
                    "Traction",
                    "Overall Sentiment",
                    "Sub-Categories",
                    "Keywords",
                    `Volume Of Posts`,
                    "Total Impact",
                    "Traction",
                    "Overall Sentiment",
                ],
            ],
        };
        // if (!this.state.showUncategorized) {
        //     data = data.filter((bkt) => bkt.label !== "Uncategorized");
        // }
        if (!this.props.showMore) {
            data = data.slice(0, 10);
        }

        let type = this.props.appliedFilter && this.props.appliedFilter.clustering_sort_by ? this.props.appliedFilter.clustering_sort_by : "volume";

        if (type !== "volume") {
            const sorting_val = type === "impact" ? "impact_score" : "traction";

            const sortAndFilterData = (d) => {
                return d
                    .sort((a, b) => {
                        return b[sorting_val] - a[sorting_val];
                    })
                    .filter((a) => a[sorting_val] !== 0)
                    .map((a) => {
                        if (a.drilldown) a.drilldown = sortAndFilterData(a.drilldown);
                        return a;
                    });
            };

            data = sortAndFilterData(data);
        }

        data.forEach((parent, index) => {
            let parent_arr = [];

            let sentimentValueIntial = `${parent.positive_percentage}% pos ${parent.negative_percentage}% neg ${parent.neutral_percentage}% neu`;
            let parentLabel = parent.label.replaceAll(",", " ");
            parent_arr.push(index + 1);
            parent_arr.push(parentLabel);
            parent_arr.push(parent.doc_count);
            parent_arr.push(parent.impact_score);
            parent_arr.push(parent.traction);
            parent_arr.push(sentimentValueIntial);
            if (parent.drilldown && parent.drilldown[0])
                if (parent.drilldown[0].drilldown && parent.drilldown[0].drilldown.length > 0) {
                    parent.drilldown.forEach((subcategory, ind) => {
                        let subcategory_arr = [];
                        if (ind === 0) subcategory_arr = parent_arr;
                        else subcategory_arr = ["", "", "", "", "", ""];
                        subcategory.drilldown.forEach((keyword, indx) => {
                            let sentimentValue = `${keyword.positive_percentage}% pos ${keyword.negative_percentage}% neg ${keyword.neutral_percentage}% neu`;
                            let label = keyword.label.replaceAll(",", " ");

                            if (indx === 0) {
                                subcategory_arr.push(subcategory.label);
                                subcategory_arr.push(label);
                                subcategory_arr.push(keyword.doc_count);
                                subcategory_arr.push(keyword.impact_score);
                                subcategory_arr.push(keyword.traction);
                                subcategory_arr.push(sentimentValue);
                                csvObj.columns.push(subcategory_arr);
                            } else {
                                let keyword_arr = [];
                                keyword_arr.push("", "", "", "", "", "", "");
                                keyword_arr.push(label);
                                keyword_arr.push(keyword.doc_count);
                                keyword_arr.push(keyword.impact_score);
                                keyword_arr.push(keyword.traction);
                                keyword_arr.push(sentimentValue);
                                csvObj.columns.push(keyword_arr);
                            }
                        });
                    });
                } else {
                    parent.drilldown.forEach((keyword, ind) => {
                        let sentimentValue = `${keyword.positive_percentage}% pos ${keyword.negative_percentage}% neg ${keyword.neutral_percentage}% neu`;
                        let label = keyword.label.replaceAll(",", " ");

                        if (ind === 0) {
                            parent_arr.push("");
                            parent_arr.push(label);
                            parent_arr.push(keyword.doc_count);
                            parent_arr.push(keyword.impact_score);
                            parent_arr.push(keyword.traction);
                            parent_arr.push(sentimentValue);
                            csvObj.columns.push(parent_arr);
                        } else {
                            let keyword_arr = [];
                            keyword_arr.push("", "", "", "", "", "", "");
                            keyword_arr.push(label);
                            keyword_arr.push(keyword.doc_count);
                            keyword_arr.push(keyword.impact_score);
                            keyword_arr.push(keyword.traction);
                            keyword_arr.push(sentimentValue);
                            csvObj.columns.push(keyword_arr);
                        }
                    });
                }
            else csvObj.columns.push(parent_arr);
        });
        return csvObj.columns;
    };

    downloadCSV = () => {
        if (this.props.isFreeTierPackage) {
            this.props.packageUpgradePopup();
            return;
        }
        downloadCSVData(this.formatData(this.props.data), this.props.widget.name);
    };

    downloadPNG = (cb, options) => {
        if (this.props.isFreeTierPackage) {
            this.props.packageUpgradePopup();
            return;
        }
        html2canvas(this.chartEl, {
            backgroundColor: options.background ? "#fff" : null,
            allowTaint: true,
            useCORS: true,
            scrollX: 0,
            scrollY: this.props.drilldown_charts ? 50 : -window.scrollY,
        }).then((canvas) => {
            cb && cb();
            downloadCanvasWithTitle(canvas, this.props.widget.name);
        });
    };

    toggleShowMore(val) {
        this.setState({ showMore: val, showMoreLoading: true }, () => {
            setTimeout(() => {
                this.setState({
                    showMoreLoading: false,
                });
            }, 600);
        });
    }

    renderDownloadButton = (nodata) => {
        return (
            <DownloadChart
                nodata={nodata}
                options={[
                    { name: "CSV", downloadFn: this.downloadCSV },
                    {
                        name: "PNG",
                        downloadFn: this.downloadPNG,
                        showLoader: true,
                        background: true,
                    },
                    {
                        name: "PNG(Transparent)",
                        downloadFn: this.downloadPNG,
                        showLoader: true,
                        background: false,
                    },
                ]}
            />
        );
    };

    createNewFilter(cluster_id, cluster_keyword) {
        let newFilter = JSON.parse(JSON.stringify(this.props.filters));
        if (this.props.drilldown_charts) newFilter = this.props.drilldown_filters && this.props.drilldown_filters.filter;

        if (!newFilter.extras) newFilter.extras = [];
        if (cluster_keyword) {
            newFilter.extras.push({ key: "clustering_category", value: cluster_id });
            newFilter.extras.push({ key: "clustering_keyword", value: cluster_keyword });
        } else {
            newFilter.extras.push({ key: "clustering_category", value: cluster_id });
        }
        if (this.props.appliedFilter.sentiment) newFilter.extras.push({ key: "Sentiment", value: this.props.appliedFilter.sentiment });
        if (this.props.appliedFilter.clustering_sort_by) {
            let sorting_val = this.props.appliedFilter.clustering_sort_by === "impact" ? "impact_value" : "latest_velocity";
            newFilter.extras.push({ key: "orderBy", value: sorting_val });
        }
        return newFilter;
    }

    handleContextMenuClick = (cluster_id, cluster_keyword) => {
        let newFilter = this.createNewFilter(cluster_id, cluster_keyword);

        this.props.handleContextMenuClick(newFilter);
    };

    handleDrilldownClick(cluster_id, cluster_keyword) {
        let newFilter = this.createNewFilter(cluster_id, cluster_keyword);

        this.props.handleDrilldownClick(newFilter);
    }

    showContextMenu = (x, y, cluster_id, cluster_keyword) => {
        if (this.props.isPublic) return;
        if (!this.props.drilldown_charts) {
            let contextMenu = d3.select(".dashboard-charts-contextmenu");
            contextMenu.attr("data-type", "clickedMenu");
            contextMenu.style("top", `${y + 10}px`);
            contextMenu.style("left", `${x - 82}px`);
            contextMenu.style("background", `#fff`);
            contextMenu.style("color", `#1a1a1a`);
            contextMenu.html(null);
            contextMenu
                .append("li")
                .text("View Conversations")
                .on("click", () => {
                    this.handleContextMenuClick(cluster_id, cluster_keyword);
                });
            !this.props.drilldown_charts &&
                contextMenu
                    .append("li")
                    .text("View Insights")
                    .on("click", () => {
                        // console.log('drilldown')
                        this.handleDrilldownClick(cluster_id, cluster_keyword);
                        // this.props.showChartsDrilldown(true, "topTopics");
                    });
            contextMenu.style("display", "block");
        }
    };

    render() {
        let nodata =
            !this.props.data ||
            (this.props.data && this.props.data.formatted_data && this.props.data.formatted_data.length === 0) ||
            this.props.noTopicsSelected;
        // console.log(this.props.data);
        return (
            <>
                <div className="dashboard-widget-container-header skiptranslate">
                    <ChartName
                        name={this.props.widget.name}
                        info="These topics are automatically generated based on your filter settings. This is based on Radarr’s advanced clustering algorithm. Top 10 topics along with sentiments are displayed. You can deep-dive into each parent topic to identify the top 10 keywords and phrases driving these topics. Right click on any topic to view the actual conversations behind these topics."
                    />
                    <div className="dashboard-widget-actions" data-html2canvas-ignore="true">
                        {!nodata && (
                            <Popup
                                trigger={
                                    <div className="chart-header-icon refresh" onClick={() => this.setState({ translateWords: true })}>
                                        <TranslateIcon />
                                    </div>
                                }
                                content="Translate Top Topics words"
                                inverted
                                size="tiny"
                                className="skiptranslate"
                                position="left center"
                            />
                        )}
                        {!this.props.isPublic &&
                            !this.props.isResearchDashboard &&
                            !this.props.drilldown_charts &&
                            this.props.dashboardPageType !== "temporaryInsights" &&
                            this.props.dashboardPageType !== "temporary" && (
                                <ChartFilterIcon
                                    chartFilterApplied={this.props.chartFilterApplied}
                                    changeShowChartFilterOptions={this.props.changeChartFilter}
                                    widgetListDashboardCurrent={this.props.widgetListDashboardCurrent}
                                    name={this.props.widget.name}
                                />
                            )}
                        {!this.props.isPublic && !this.props.isResearchDashboard ? <>{this.renderDownloadButton(nodata)}</> : null}
                        {
                            <>
                                {this.props.isPublic && nodata
                                    ? null
                                    : !this.props.drilldown_charts && (
                                          <Popup
                                              className="skiptranslate"
                                              trigger={
                                                  this.props.expandWidget ? (
                                                      <MiniMize className="chart-header-icon" onClick={this.props.expandFullWidget} />
                                                  ) : (
                                                      <MaxiMize className="chart-header-icon" onClick={this.props.expandFullWidget} />
                                                  )
                                              }
                                              inverted
                                              content={this.props.expandWidget ? "Minimize Widget" : "Maximize Widget"}
                                              size="mini"
                                              position="bottom center"
                                              style={{ zIndex: "99999" }}
                                          />
                                      )}
                            </>
                        }
                        {(this.props.isPublic && nodata) || this.props.drilldown_charts ? null : (
                            <MoreOptions className="more-options" onClick={(e) => this.props.changeShowMoreOptions(e)} />
                        )}
                    </div>
                </div>
                {this.props.showMoreOptions && (
                    <ChartOptionsSidebar
                        data-html2canvas-ignore="true"
                        showMoreOptionsLoc={this.props.showMoreOptionsLoc}
                        changeShowMoreOptions={this.props.changeShowMoreOptions}>
                        {!nodata && (
                            <Popup
                                className="skiptranslate"
                                content="Only top 10 clusters are shown by default. Click here to view additional that are available."
                                inverted
                                size="tiny"
                                trigger={
                                    <CustomCheckBox
                                        checked={this.props.data.data.length > 10 && this.props.showMore}
                                        onClick={() => (this.props.showMore ? this.props.toggleShowMore(false) : this.props.toggleShowMore(true))}
                                        label="View More Clusters"
                                        disabled={this.props.data.data.length < 11}
                                    />
                                }
                            />
                        )}
                        <VolumeSelector appliedFilter={this.props.appliedFilter} handleSortByChange={this.handleSortByChange} />
                        <SentimentSelector
                            aggs_val={this.props.aggs_val}
                            appliedFilter={this.props.appliedFilter}
                            handleSentimentChange={this.handleSentimentChange}
                        />
                        {!this.props.isPublic &&
                            !this.props.isStandardDashboard &&
                            !this.props.isResearchDashboard &&
                            this.props.dashboardPageType !== "temporaryInsights" &&
                            this.props.dashboardPageType !== "temporary" && (
                                <>
                                    <div className="chart-settings menu-option" onClick={this.props.chartSettings}>
                                        <span>Chart Configuration</span>
                                        <Settings />
                                    </div>
                                    <div className="clone-chart menu-option" onClick={this.props.cloneWidget}>
                                        <span>Clone Chart</span>
                                        <CloneIcon />
                                    </div>
                                </>
                            )}
                        {!this.props.isPublic &&
                            !this.props.isStandardDashboard &&
                            !this.props.isResearchDashboard &&
                            this.props.dashboardPageType !== "temporaryInsights" &&
                            this.props.dashboardPageType !== "temporary" && <DeleteWidget onClick={this.props.deleteWidget} />}
                    </ChartOptionsSidebar>
                )}

                {!nodata ? (
                    <div className="dashboard-chart toptopics skiptranslate" ref={(chartEl) => (this.chartEl = chartEl)}>
                        {!this.props.showMoreLoading && (
                            <TopTopicsChart
                                data={this.props.data}
                                appliedFilter={this.props.appliedFilter}
                                addContextMenuListener={this.addContextMenuListener}
                                sentiment={this.state.sentiment}
                                showContextMenu={this.showContextMenu}
                                showMore={this.props.showMore}
                                showGridLines={this.props.showGridLines}
                                // resizedCount={this.props.resizedCount}
                                showLabel={this.props.showLabel}
                                widgetContainerRef={this.props.widgetContainerRef}
                            />
                        )}
                        {this.props.showMoreLoading && <DimmerComponent />}
                    </div>
                ) : (
                    <NoData
                        message={
                            !this.props.isPublic && this.props.noTopicsSelected
                                ? "To view charts, please select topics using either the page filters on the left or the chart filters on this chart."
                                : null
                        }
                    />
                )}
                <TranslateWords
                    showMore={this.props.showMore}
                    data={this.props.data}
                    appliedFilter={this.props.appliedFilter}
                    open={this.state.translateWords}
                    onClose={() => this.setState({ translateWords: false })}
                    companyLiteID={this.props.companyLiteID}
                />
            </>
        );
    }
}

function mapStateToProps(state) {
    return {
        // data: state.csApiReducer.topInfluencers,
        //allPlatforms: state.globalReducer.filterOptions ? state.globalReducer.filterOptions.platforms : [],
        allPlatforms: state.filterSettingReducer.masterPlatforms,
        widgetListDashboardCurrent: state.dashboardReducer.widgetListDashboardCurrent,
        drilldown_filters: state.dashboardReducer.drilldown_filters,
        maximizeWidgetValue: state.dashboardReducer.maximizeWidgetValue,
        companyLiteID: state.globalReducer.company.company_lite_company_id,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        showChartsDrilldown: (bool, name) => dispatch(showChartsDrilldown(bool, name)),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(TopTopics);
